export const PALLET = {
  brown: '#8D6752',
  brownHover: '#b28e7a',

  lightBrown: '#AB8586',

  brown2: '#3C3D3C',

  purple: '#4800E2',

  white: '#fff',
  whiteHover: '#bfbfbf',
  whiteDisabled: '#b3b3b3',
  tableBorder: '#3f3f3f',
  lighGray: '#EBECEC',

  red: '#FF6B6B',
  red2: '#FF8989',
  red3: '#FF5353',
  redHover: '#ba4d4d',
  redOpacity: 'rgba(255, 107, 107, 0.2)',

  yellow: '#F3BA2F',
  yellow2: '#FFDD8B',
  darkYellow: '#c99452',

  green: '#16C79A',
  greenHover: '#33e0b5',
  lightGreen: '#FFE400',
  darkGreen: '#bbce46',

  blueOutline: '#2684FF',
  lightBlue: '#55d1b2',

  cyan: '#34b98e',
  orange: '#e49b40',
  darkRed: '#c05656',

  black: '#000',
  midNightBlack: '#191919',
  blackLight: 'rgba(0, 0, 0, 0.15)',

  gray: '#A5A5A5',
  grayHover: '#fff',

  gray2: '#4b4c56',
  gray3: '#313131',
  gray4: '#2D2E34',
  gray5: '#494949',
  gray6: '#656565',

  gray7: '#5B5B5B',
  gray7Hover: '#818181',

  gray8: '#4E4E4E',

  gray9: '#404040',
  gray9Hover: '#737373',

  gray10: '#42434B',
  gray10hover: '#36373d',

  gray11: '#3A3A3A',
  gray12: '#7c7c7c',
  gray13: '#2C2D32',

  darkGray: '#27282D',
  darkGrayHover: '#3f4048',

  darkGray2: '#212227',

  darkGray3: '#1E1E1E',

  darkPurple: '#926CE3',
  purple2: '#C7B4F2',
  lightPurple: '#E2D6FF',

  twitter: '#03A9F4',
  twitterHover: '#60ccfd',

  facebook: '#1976D2',
  facebookHover: '',

  email: '#A5A5A5',
  emailHover: '',

  linkedin: '#FF5722',
  linkedinHover: '',

  telegram: '#61A8DE',
  telegramHover: '',

  grayOpacity: 'rgba(117, 117, 117, 0.28)',
  grayOpacityHover: 'rgba(168, 168, 168, 0.28)',

  transparent: 'transparent',

  disabled: '#8C8C8C',
};

export default {
  main: {
    '--color-main': PALLET.brown,
    '--color-bg': PALLET.darkGray2,
    '--color-bg-hover': PALLET.darkGrayHover,
    '--color-title': PALLET.white,
    '--color-subtitle': PALLET.white,
    '--ligh-gray': PALLET.lighGray,

    '--color-link': PALLET.green,
    '--color-link-hover': PALLET.greenHover,

    '--color-link-disabled': PALLET.disabled,

    '--color-button': PALLET.white,
    '--color-button-hover': PALLET.whiteHover,
    '--button-back-border': PALLET.green,
    '--button-back-bg': PALLET.darkGray,
    '--button-back-bg-hover': PALLET.darkGrayHover,
    '--button-back': PALLET.green,

    '--header-bgd': PALLET.darkGray,
    '--header-navicon': PALLET.white,
    '--header-navicon-hover': PALLET.whiteHover,
    '--header-box': PALLET.white,

    '--header-link': PALLET.gray,
    '--header-link-hover': PALLET.grayHover,

    '--connect-wallet-button-bg': PALLET.darkGray,
    '--connect-wallet-button-border': PALLET.white,
    '--connect-wallet-button-hovered': PALLET.whiteHover,
    '--connect-wallet-button-connected': PALLET.green,
    '--connect-wallet-button-disconnected': PALLET.gray5,

    '--footer-text': PALLET.gray,
    '--table-border': PALLET.tableBorder,

    '--modal-box-shadow': PALLET.black,
    '--modal-box-bgd': PALLET.darkGray,
    '--modal-header-title': PALLET.white,
    '--modal-header-close': PALLET.gray,
    '--modal-header-line': PALLET.gray3,
    '--modal-provider-bgd': PALLET.gray4,
    '--modal-white': PALLET.white,
    '--modal-gray': PALLET.gray,

    '--button-white': PALLET.white,
    '--button-red': PALLET.red,
    '--button-red3': PALLET.red3,
    '--button-twitter': PALLET.twitter,
    '--button-green': PALLET.green,
    '--button-gray': PALLET.gray,
    '--button-background-transparent': PALLET.transparent,

    '--select-background': PALLET.darkGray,
    '--select-placeholder-color': PALLET.white,
    '--select-placeholder-hover': PALLET.whiteHover,
    '--select-list-background': PALLET.darkGray,
    '--select-list-item': PALLET.gray,
    '--select-option-is-focused': PALLET.white,

    '--dropdown-background': PALLET.darkGray,
    '--dropdown-list-item': PALLET.darkGray,
    '--dropdown-list-item-hover': PALLET.darkGrayHover,
    '--dropdown-list-item-text': PALLET.green,
    '--dropdown-list-item-text-hover': PALLET.whiteHover,
    '--dropdown-circle-background': PALLET.darkGray,
    '--dropdown-circle-border': PALLET.white,

    '--message-box-text': PALLET.white,
    '--message-box-error-bgd': PALLET.red,
    '--message-box-success-bgd': PALLET.green,
    '--message-box-status-icon-border': PALLET.white,

    '--tooltip-bg-before': PALLET.gray2,
    '--tooltip-bg': PALLET.darkGray,
    '--tooltip-bg-border': PALLET.brown,
    '--tooltip-text': PALLET.white,

    '--transaction-button-error-icon-stroke': PALLET.red,

    '--loader-circle': PALLET.white,

    '--box-item-bg': PALLET.darkGray,
    '--box-item-title': PALLET.brown,
    '--box-item-value': PALLET.white,
    '--box-item-box-shadow': PALLET.blackLight,
    '--box-item-value-err': PALLET.red,
    '--box-item-small-num': PALLET.white,
    '--box-item-small-num-error': PALLET.red,

    '--input-border': PALLET.gray7,
    '--input-text': PALLET.gray,
    '--input-text-placeholder': PALLET.gray6,
    '--input-text-label': PALLET.gray6,
    '--input-label': PALLET.brown,
    '--input-label-hover': PALLET.brownHover,
    '--input-max-loading': PALLET.white,
    '--input-max-error': PALLET.red,
    '--input-max-label': PALLET.green,
    '--input-max-label-hover': PALLET.greenHover,
    '--input-max-label-disabled': PALLET.gray,
    '--input-error-border': PALLET.red,
    '--input-error-bg': PALLET.redOpacity,
    '--input-error-text': PALLET.red2,
    '--input-focus-border': PALLET.blueOutline,
    '--input-counter': PALLET.gray,
    '--input-with-balance-second-label': PALLET.gray,
    '--input-with-balance-background': PALLET.gray4,
    '--input-with-balance-border-max': PALLET.gray,
    '--input-with-balance-input': PALLET.white,

    '--select-border': PALLET.gray,

    '--error-text': PALLET.red,

    '--form-submit-bg': PALLET.green,
    '--form-submit-bg-hover': PALLET.greenHover,
    '--form-submit-disabled': PALLET.gray,
    '--forms-rewards-box-bg': PALLET.gray4,

    '--landing-description': PALLET.green,
    '--landing-additional-description': PALLET.gray,

    '--select-bg': PALLET.darkGray,
    '--select-hover-bg': PALLET.brownHover,
    '--select-hover-selected-border': PALLET.blueOutline,
    '--select-placeholder': PALLET.gray,
    '--select-arrow': PALLET.white,
    '--select-value': PALLET.white,
    '--select-menu-bg': PALLET.darkGray,
    '--select-menu-option': PALLET.gray,
    '--select-menu-option-selected-bg': PALLET.grayOpacity,
    '--select-menu-option-selected-bg-hover': PALLET.grayOpacityHover,

    '--search-select-input': PALLET.white,
    '--search-select-input-focused-border': PALLET.blueOutline,
    '--search-select-input-border': PALLET.gray7,
    '--search-select-input-bg': PALLET.darkGray,
    '--search-select-input-placeholder': PALLET.gray,

    '--tokens-list-search-input': PALLET.white,
    '--tokens-list-search-focused-border': PALLET.blueOutline,
    '--tokens-list-search-input-bg': PALLET.darkGray,
    '--tokens-list-search-input-border': PALLET.gray7,
    '--tokens-list-input-placeholder': PALLET.gray,
    '--tokens-list-search-menu-border': PALLET.gray7,
    '--tokens-list-search-menu-bg': PALLET.darkGray,
    '--tokens-list-search-menu-text': PALLET.gray,
    '--tokens-list-search-menu-result-name': PALLET.white,
    '--tokens-list-search-menu-result-address': PALLET.brown,
    '--tokens-list-search-menu-result-hover-bg': PALLET.gray4,

    '--hpool-gray': PALLET.gray,
    '--hpool-navigation-border': PALLET.brown,
    '--hpool-navigation-color': PALLET.white,
    '--hpool-navigation-active': PALLET.brown,
    '--hpool-form-background': PALLET.darkGray,
    '--hpool-form-label-color': PALLET.white,
    '--hpool-info-item-color': PALLET.brown,
    '--hpool-info-text-color': PALLET.white,
    '--hpool-input-disabled': PALLET.gray4,

    '--thumbnail-button-icon-background': PALLET.gray,
    '--thumbnail-button-icon-stroke': PALLET.gray,
    '--thumbnail-button-icon-wrapper': PALLET.gray,
    '--thumbnail-button-submitting': PALLET.green,
    '--thumbnail-button-submit-text': PALLET.white,
    '--thumbnail-button-name-wrapper': PALLET.gray,

    '--dropzone-no-file': PALLET.gray,
    '--dropzone-no-file-border': PALLET.gray,
    '--dropzone-title': PALLET.gray,
    '--dropzone-name-wrapper-border': PALLET.gray,
    '--dropzone-progress-border': PALLET.gray,
    '--dropzone-new-file-border': PALLET.gray,

    '--prefix': PALLET.gray,

    '--back-color': PALLET.white,

    '--loader-default-bg': PALLET.gray8,
    '--loader-default-loading-bg': PALLET.brown,
    '--loader-message': PALLET.gray,

    '--dot-typing': PALLET.white,

    '--nft-box-stats-bg': PALLET.darkGray,
    '--nft-box-border-hover': PALLET.brown,
    '--nft-box-champion-box-bg': PALLET.brown,
    '--nft-box-champion-box-handle': PALLET.darkGray,
    '--nft-box-champion-box-handle-hover': PALLET.gray2,
    '--nft-box-top-overlay-bg': PALLET.darkGray,

    '--textarea-bg': PALLET.darkGray,

    '--nft-stat-title': PALLET.brown,
    '--nft-stat-value': PALLET.white,

    '--champion-box-bg': PALLET.darkGray,
    '--champion-box-bg-hover': PALLET.brownHover,
    '--champion-box-name': PALLET.white,
    '--champion-box-handle': PALLET.gray7,

    '--not-connected-blocker-text': PALLET.white,
    '--checker-loader-text': PALLET.white,

    '--portfolio-subtitle': PALLET.gray,

    '--portfolio-single-nft-content-item-bg': PALLET.darkGray,
    '--portfolio-single-nft-stakes-title': PALLET.white,
    '--portfolio-single-nft-single-stake-border': PALLET.gray3,
    '--portfolio-single-nft-single-stake-small-item-title': PALLET.brown,
    '--portfolio-single-nft-single-stake-small-item-value': PALLET.white,
    '--portfolio-single-nft-single-stake-withdrawn-badge-bg': PALLET.yellow,

    '--empty-state-text': PALLET.white,

    '--champion-socials-link-text': PALLET.white,
    '--champion-socials-link': PALLET.gray9,
    '--champion-socials-link-hover': PALLET.gray9Hover,
    '--champion-socials-edit': PALLET.gray10,
    '--champion-socials-edit-hover': PALLET.gray10hover,
    '--champion-socials-empty': PALLET.green,
    '--champion-socials-empty-hover': PALLET.greenHover,
    '--champion-socials-empty-bgd': PALLET.darkGray,

    '--champion-nft-box-bgd': PALLET.darkGray,
    '--champion-nft-text': PALLET.white,
    '--champion-nft-about': PALLET.gray,
    '--champion-share-title': PALLET.white,
    '--champion-viewer-about': PALLET.gray4,
    '--champion-viewer-name': PALLET.white,
    '--champion-viewer-nft-description': PALLET.gray,
    '--champion-viewer-nft-text': PALLET.white,
    '--champion-viewer-nft-require': PALLET.yellow,
    '--champion-viewer-sold-out': PALLET.red3,
    '--champion-viewer-sold-out-text': PALLET.white,
    '--champion-viewer-success-link-hover': PALLET.whiteHover,
    '--champion-legend-deposit': PALLET.gray,
    '--champion-legend-subscribtion-failed': PALLET.red3,
    '--champion-legend-creating': PALLET.brown,
    '--champion-legend-ticket-sale': PALLET.darkYellow,
    '--champion-legend-subscription': PALLET.lightGreen,
    '--champion-legend-darker-subscription': PALLET.darkGreen,
    '--champion-legend-deploying': PALLET.lightBlue,
    '--champion-legend-live': PALLET.cyan,
    '--champion-legend-updating': PALLET.orange,
    '--champion-legend-ending': PALLET.darkRed,
    '--champion-legend-ended': PALLET.gray12,

    '--create-hpool-form-desc': PALLET.gray,
    '--create-hpool-navigation-border': PALLET.brown,
    '--create-hpool-navigation-color': PALLET.white,
    '--create-hpool-navigation-active': PALLET.brown,
    '--create-hpool-slider-tokens-list-section-title': PALLET.brown,
    '--create-hpool-slider-token-bg': PALLET.darkGray,
    '--create-hpool-slider-additional-text': PALLET.gray,
    '--create-hpool-slider-token-icon-bg': PALLET.gray10,
    '--create-hpool-slider-token-name': PALLET.white,
    '--create-hpool-slider-token-link': PALLET.gray,
    '--create-hpool-slider-token-link-hover': PALLET.grayHover,
    '--create-hpool-slider-token-percentage': PALLET.white,
    '--create-hpool-slider-token-empty-text': PALLET.gray,
    '--create-hpool-slider-token-locked': PALLET.red3,
    '--create-hpool-slider-token-locked-hover': PALLET.red,
    '--create-hpool-review-container-border': PALLET.gray3,
    '--create-hpool-skip': PALLET.gray,
    '--create-hpool-skip-hover': PALLET.grayHover,

    '--yellow-box': PALLET.yellow2,
    '--yellow-box-text': PALLET.darkGray2,

    '--tokens-percentages-full-list-token-name': PALLET.white,
    '--tokens-percentages-full-list-token-link': PALLET.gray,
    '--tokens-percentages-full-list-token-link-hover': PALLET.grayHover,
    '--tokens-percentages-full-list-token-percentage': PALLET.white,
    '--tokens-percentages-full-list-token-percentage-bar-bg': PALLET.darkGray3,
    '--tokens-percentages-full-list-toggle-list-button': PALLET.green,
    '--tokens-percentages-full-list-toggle-list-button-hover': PALLET.greenHover,

    '--token-verified-on-token-lists': PALLET.gray,

    '--tokens-percentages-bar-last-remaining-bg': PALLET.lightBrown,
    '--tokens-percentages-bar-last-other': PALLET.green,

    '--nft-status-sold-out-bg': PALLET.red3,
    '--nft-status-sold-out': PALLET.white,
    '--nft-status-almost-bg': PALLET.yellow,

    '--paginator-bg': PALLET.darkGray,

    '--single-tag-bg': PALLET.gray11,
    '--single-tag-text': PALLET.white,

    '--slider-handle-bg': PALLET.brown,
    '--slider-rail': PALLET.darkGray3,
    '--slider-track': PALLET.brown,

    '--url-link-container': PALLET.gray4,
    '--pool-text': PALLET.gray,
    '--close-pool-button': PALLET.red3,
    '--close-pool-button-hover': PALLET.redHover,
    '--green-for-pool-texts-and-numbers': PALLET.green,
    '--single-text': PALLET.white,
    '--edit-about-box-text': PALLET.gray,
    '--send-tickets-text': PALLET.gray,
    '--input-value': PALLET.white,

    '--balance-box-border': PALLET.gray3,
    '--yellow-text': PALLET.yellow2,

    '--ticket-input-border': PALLET.darkGray,
    '--amount-input': PALLET.gray4,

    '--bottom-border': PALLET.gray3,

    '--tabs-brown': PALLET.brown,
    '--text-color-darkgrey': PALLET.darkGray,
    '--yellow-withdrawn-box': PALLET.yellow,

    '--updated-tokens-list-item': PALLET.gray4,
    '--token-status': PALLET.brown,
    '--filters-toolbar-color': PALLET.white,
    '--filter-color': PALLET.white,
    '--filter-bg': PALLET.gray13,
    '--filter-item-active-bg': PALLET.green,
  },
  vpool: {
    '--color-bg': PALLET.midNightBlack,
    '--hpool-info-item-color': PALLET.purple,
    '--vpool-whitelist': PALLET.darkPurple,
    '--vpool-participation': PALLET.purple2,
    '--vpool-live': PALLET.lightPurple,
  },
};
